import DodoablesListItem from 'app/dodoables/list/Item'

export default ({ dodoables, ListItemElement, scroll = true }) => {
  const ListItem = ListItemElement || DodoablesListItem
  const style = {}

  if (scroll) style['overflowY'] = 'scroll'

  return (
    <div className="fcol flex-1 dodoables-list">
      <div className="fcol flex-1" style={style}>
        {dodoables.map((dodoable) => {
          return <ListItem key={dodoable.id} dodoable={dodoable} />
        })}
      </div>
    </div>
  )
}
